// extracted by mini-css-extract-plugin
export var MainNavigationMenu = "MainNavigationMenu-module--MainNavigationMenu--e6fb5";
export var MenuVisible = "MainNavigationMenu-module--Menu--visible--2ae3d";
export var Menu__List = "MainNavigationMenu-module--Menu__List--28144";
export var Menu__ListItem = "MainNavigationMenu-module--Menu__ListItem--0abac";
export var Menu__ListItemHasChildren = "MainNavigationMenu-module--Menu__ListItem--hasChildren--b83e1";
export var Menu__ListItem__Link = "MainNavigationMenu-module--Menu__ListItem__Link--28c52";
export var Menu__ListItem__LinkActive = "MainNavigationMenu-module--Menu__ListItem__Link--active--08124";
export var Menu__ListItem__Link__Arrow = "MainNavigationMenu-module--Menu__ListItem__Link__Arrow--6dcb1";
export var Menu__ListItem__Link__Text = "MainNavigationMenu-module--Menu__ListItem__Link__Text--4a5ab";